import { render, staticRenderFns } from "./formbuilderView.vue?vue&type=template&id=561a0a8a&scoped=true"
import script from "./formbuilderView.vue?vue&type=script&lang=js"
export * from "./formbuilderView.vue?vue&type=script&lang=js"
import style0 from "./formbuilderView.vue?vue&type=style&index=0&id=561a0a8a&prod&lang=scss&scoped=true"
import style1 from "./formbuilderView.vue?vue&type=style&index=1&id=561a0a8a&prod&lang=scss"
import style2 from "./formbuilderView.vue?vue&type=style&index=2&id=561a0a8a&prod&lang=scss&scoped=true"
import style3 from "./formbuilderView.vue?vue&type=style&index=3&id=561a0a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a0a8a",
  null
  
)

export default component.exports